var _style, _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoGlasses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 794 794",
    width: 794,
    height: 794,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffc8a2;stroke: #000000;stroke-miterlimit:100;stroke-width: 2 } \n\t\t.s1 { fill: #000000 } \n\t\t.s2 { fill: #7a7a7a } \n\t\t.s3 { fill: #000000;stroke: #000000;stroke-miterlimit:100;stroke-width: 0 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer 5",
    className: "s0",
    d: "m321 580c-118.3 0-214-103.7-214-232 0-128.3 95.7-232 214-232 118.3 0 214 103.7 214 232 0 128.3-95.7 232-214 232z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer 3",
    className: "s1",
    d: "m259.3 201.5c0 0 21.9 93.6 30.8 97.7 10.3 4.7 62.6 8.3 91.5 4.2 5.7-0.8 6.6-64.2 8.8-64.4 2.4-0.2 1.6 63.5 8.2 63.5 13.5 0 38.1 3.1 52.7 3 2 0 4.6-39.6 6.8-39.5 1.8 0 1.2 40.7 3.1 41.2 12.9 2.7 27.7 7.1 32.1 12.4 25.7 30.4-9 221.8-9 221.8 0 0 91.7-109.7 97.7-174.4 5.5-59.9-7.9-173-97-253-89.1-80-155.8-69-205-68-49.2 1-144 61.5-184 170-40 108.5-26.1 142.8-21.6 192.4 4.5 50.2 96.9 146.5 96.9 146.5 0 0-41.2-159.3-28.7-227.8 13.4-24.7 70.8-18.6 90.5-28 5.8-5.5 26.2-97.6 26.2-97.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer 2",
    className: "s2",
    d: "m73.9 739c-8.2-7.7-25.5-280.8-14.2-290.5 11.9-10.1 520.5-8 521.2 3.2 9.7 15.5 3.8 268.8-18.8 287.1-15.4 12.5-475.6 12-488.2 0.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape 1",
    className: "s0",
    d: "m648.2 723l-16.2-134.9 105-0.8-16.7 135.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 2",
    className: "s3",
    d: "m662.2 714.2c-6.1 0-11.1-5-11.1-11.1 0-6.1 5-11 11.1-11 6.1 0 11 4.9 11 11 0 6.1-4.9 11.1-11 11.1zm34.5 0c-5.7 0-10.3-4.6-10.3-10.3 0-5.7 4.6-10.3 10.3-10.3 5.7 0 10.3 4.6 10.3 10.3 0 5.7-4.6 10.3-10.3 10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 3",
    className: "s3",
    d: "m679.8 687.7c-5.3 0-9.6-4.3-9.6-9.6 0-5.2 4.3-9.5 9.6-9.5 5.3 0 9.6 4.3 9.6 9.5 0 5.3-4.3 9.6-9.6 9.6zm33.1 1.5c-5.7 0-10.3-4.6-10.3-10.3 0-5.7 4.6-10.3 10.3-10.3 5.7 0 10.3 4.6 10.3 10.3 0 5.7-4.6 10.3-10.3 10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 4",
    className: "s3",
    d: "m698.7 587.1l-0.7-49.5 15.6 0.4-1.1 49.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGlasses);
export default __webpack_public_path__ + "static/media/no-glasses.8302dc6a548cad503b120f80e7dbb155.svg";
export { ForwardRef as ReactComponent };